'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Image = require('../../atoms/Image');

var _Image2 = _interopRequireDefault(_Image);

var _Carousel = require('../Carousel');

var _Carousel2 = _interopRequireDefault(_Carousel);

require('./image-gallery.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageGallery = function (_React$Component) {
  _inherits(ImageGallery, _React$Component);

  function ImageGallery() {
    _classCallCheck(this, ImageGallery);

    return _possibleConstructorReturn(this, (ImageGallery.__proto__ || Object.getPrototypeOf(ImageGallery)).apply(this, arguments));
  }

  _createClass(ImageGallery, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          businessName = _props.businessName,
          images = _props.images,
          isInstagram = _props.isInstagram,
          handle = _props.handle,
          link = _props.link;

      return _react2.default.createElement(
        'div',
        { id: 'image-gallery-container' },
        _react2.default.createElement(
          'div',
          { id: 'image-gallery' },
          images.map(function (url) {
            return _react2.default.createElement('div', { id: 'image-gallery-image', key: url, style: { backgroundImage: 'url(' + url + ')' } });
          }),
          images.length % 2 !== 0 && _react2.default.createElement(
            'div',
            { id: 'image-gallery-placeholder' },
            isInstagram ? _react2.default.createElement(
              'a',
              { href: link, target: '_blank', rel: 'noopener' },
              _react2.default.createElement(
                'div',
                { id: 'image-gallery-placeholder-content' },
                '@',
                handle
              )
            ) : _react2.default.createElement(
              'div',
              { id: 'image-gallery-placeholder-content' },
              businessName
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { id: 'image-gallery-carousel' },
          _react2.default.createElement(
            _Carousel2.default,
            null,
            images.map(function (image) {
              return _react2.default.createElement(_Image2.default, { key: image, src: image, alt: 'Image' });
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { id: 'image-gallery-mobile-carousel' },
          _react2.default.createElement(
            _Carousel2.default,
            { displayItems: 1 },
            images.map(function (image) {
              return _react2.default.createElement(_Image2.default, { key: image, src: image, alt: 'Image' });
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { id: 'image-gallery-see-more-btn' },
          isInstagram && _react2.default.createElement(
            'a',
            { href: link, target: '_blank', rel: 'noopener' },
            _react2.default.createElement(
              'button',
              null,
              'SEE MORE'
            )
          )
        )
      );
    }
  }]);

  return ImageGallery;
}(_react2.default.Component);

exports.default = ImageGallery;
;

ImageGallery.propTypes = {
  businessName: _propTypes2.default.string.isRequired,
  images: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  isInstagram: _propTypes2.default.bool,
  handle: _propTypes2.default.string,
  link: _propTypes2.default.string
};

ImageGallery.defaultProps = {
  isInstagram: false,
  handle: '',
  link: ''
};


//////////////////
// WEBPACK FOOTER
// ./~/@fishrmn/fishrmn-components/build/components/molecules/ImageGallery/ImageGallery.js
// module id = 489
// module chunks = 168707334958949